import React from 'react'

export default function DynamicComponent(props) {

  const TagName = props.component

  return <TagName {...props}/>
}